import React, { useContext } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import Constant from "../Constants";
import ThemeContext from "../../utils/Contexts/ThemeContext";
import TotalBalance from "./Sections/TotalBalance";
import LatestTransaction from "./Sections/LatestTransaction";
import OnHold from "./Sections/OnHold";
import AccountCards from "./Sections/AccountCards";
import Announcement from "./Sections/Announcement";
import CashFlow from "./Sections/CashFlow";

import "./style.css";

function Balance() {
  const { t } = useContext(LanguageContext);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);

  return (
    <main
      id="balance"
      role="main"
      className={`main ${themeStatus?.[selectedTheme]}`}
    >
      <div className="content container-fluid">
        <div
          className="page-header pb-0 mb-2"
          style={{ borderBottom: "unset" }}
        >
          <div className="row">
            <div className="d-flex justify-content-between align-items-center mb-sm-2 mb-2 mb-md-0">
              <div>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-no-gutter">
                    <li className="breadcrumb-item">
                      {/* eslint-disable-next-line */}
                      <a href="javascript:;" className="breadcrumb-link">
                        {t("Wallet")}
                      </a>
                    </li>
                  </ol>
                </nav>
                <h1 className="page-header-title">{t("Balance")}</h1>
              </div>
              <div>
                <button
                  className="btn text-center get-paid-btn d-flex justify-content-center align-items-center"
                  style={{
                    backgroundColor: "rgba(56, 124, 255, 1)",
                    color: "rgba(255, 255, 255, 1)",
                  }}
                >
                  {t("Get Paid Now")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="mb-4"
          style={{
            borderBottom: `.0625rem solid var(--border)`,
            marginLeft: "-30px",
            marginRight: "-30px",
          }}
        ></div>
        <div className="row space-balance">
          <div className="col-12 col-1024-6 col-1920-4 space-total">
            <TotalBalance />
          </div>
          <div className="col-12 col-1024-6 col-1920-5 space-card">
            <AccountCards />
          </div>
          <div className="col-12 col-1024-12 col-1920-3 space-announcement">
            <Announcement />
          </div>
          <div className="col-12" style={{ marginTop: "1.2rem" }}>
            <CashFlow />
          </div>
          <div className="col-12" style={{ marginTop: "1.2rem" }}>
            <LatestTransaction />
          </div>
          <div className="col-12" style={{ marginTop: "1.2rem" }}>
            <OnHold />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Balance;
